import { TenantSettingsViewModel } from "../models/preplabModels";
import { useFetchApiData } from "./useFetchApiData";

export const useGetSettings = (tenantId?: string) => {
    return useFetchApiData<TenantSettingsViewModel>("/api/Settings/GetSettings", tenantId);
};
